import { useMessageSource } from "react-message-source";
import { useFormatNumber } from "../shared/hooks/useFormatNumber";
import { AnnualFlightSpending } from "./types";

export type UseAnnualFlightSpendingOptionType = {
  id: string;
  value: string;
  label: string;
};

export function useAnnualFlightSpendingOptions(): UseAnnualFlightSpendingOptionType[] {
  const { getMessage } = useMessageSource();
  const { formatStringAsAmount } = useFormatNumber();

  return [
    {
      id: AnnualFlightSpending.LESS_THAN_10,
      value: AnnualFlightSpending.LESS_THAN_10,
      label: getMessage("ValueRange.lessThan", formatStringAsAmount("10000")),
    },
    {
      id: AnnualFlightSpending.BETWEEN_10_AND_100,
      value: AnnualFlightSpending.BETWEEN_10_AND_100,
      label: getMessage(
        "ValueRange.between",
        formatStringAsAmount("10000"),
        formatStringAsAmount("100000"),
      ),
    },
    {
      id: AnnualFlightSpending.BETWEEN_100_AND_200,
      value: AnnualFlightSpending.BETWEEN_100_AND_200,
      label: getMessage(
        "ValueRange.between",
        formatStringAsAmount("100001"),
        formatStringAsAmount("200000"),
      ),
    },
    {
      id: AnnualFlightSpending.OVER_200,
      value: AnnualFlightSpending.OVER_200,
      label: getMessage(
        "ValueRange.greaterThan",
        formatStringAsAmount("200000"),
      ),
    },
  ];
}
